import {
  ArrowLeftRight,
  Bitcoin,
  Building2,
  ChartColumn,
  CircleDollarSign,
  CreditCard,
  CreditCardIcon,
  HandCoins,
  Import,
  LayoutDashboard,
  LayoutDashboardIcon,
  LogIn,
  MessageCircleQuestion,
  PiggyBank,
  ReceiptText,
  Settings2,
  ShieldEllipsis,
  TicketCheck,
  User,
  Users,
} from "lucide-react";

export interface SubLink {
  title: string;
  url: string;
  icon: React.ReactNode;
  requiresBankRequisites?: boolean; // Flag for conditional rendering
}

export interface NavLink {
  title: string;
  url: string;
  icon: React.ReactNode;
  subLinks?: SubLink[];
}

export const links: NavLink[] = [
  {
    title: "Log in",
    url: "/login",
    icon: <LogIn />,
  },
  {
    title: "Profile",
    url: "/profile",
    icon: <User />,
  },
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: <LayoutDashboardIcon />,
  },
  {
    title: "Exchange",
    url: "/exchange",
    icon: <CircleDollarSign />,
  },
  {
    title: "Deposit",
    url: "/deposit",
    icon: <CreditCardIcon />,
    subLinks: [
      { title: "CreditCard", url: "/deposit/card", icon: <CreditCard /> },
      { title: "Crypto", url: "/deposit/crypto", icon: <Bitcoin /> },
      { title: "Bank", url: "/deposit/bank", icon: <Building2 />, requiresBankRequisites: true },
    ],
  },
  {
    title: "Withdraw",
    url: "/withdraw",
    icon: <HandCoins />,
    subLinks: [
      { title: "Crypto", url: "/withdraw/crypto", icon: <Bitcoin /> },
      { title: "Bank", url: "/withdraw/bank", icon: <PiggyBank /> },
      { title: "Card", url: "/withdraw/card", icon: <CreditCard /> },
    ],
  },
  {
    title: "Transactions",
    url: "/transactions",
    icon: <ArrowLeftRight />,
  },
  {
    title: "Invoices",
    url: "/invoices",
    icon: <ReceiptText />,
  },
  /* {
    title: "Postbacks",
    url: "/postbacks",
    icon: <Cable />,
    subLinks: [
      { title: "List", url: "/postbacks/list", icon: <List /> },
      { title: "Chats", url: "/postbacks/chats", icon: <MessageCircle /> },
    ],
  }, */
  {
    title: "Support",
    url: "/chats",
    icon: <MessageCircleQuestion />,
  },
];
